import React from "react";
import { string } from "prop-types";
import cx from "classnames";

const propTypes = {
  className: string,
};

const PlusIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      className={cx("plus-icon", className)}
    >
      <line
        className="plus-icon__vertical-line"
        x1="12"
        y1="5"
        x2="12"
        y2="19"
      ></line>
      <line
        className="plus-icon__horizontal-line"
        x1="5"
        y1="12"
        x2="19"
        y2="12"
      ></line>
      <rect
        className="plus-icon__square"
        x="11"
        y="11"
        width="2"
        height="2"
        transform="rotate(45 12 12)"
        fill="currentColor"
      ></rect>
    </svg>
  );
};

PlusIcon.propTypes = propTypes;
export default PlusIcon;
